/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_Banner_UploadedInputs */

const en_link_editor_banner_uploaded = /** @type {(inputs: Link_Editor_Banner_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banner image uploaded`)
};

const es_link_editor_banner_uploaded = /** @type {(inputs: Link_Editor_Banner_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagen de banner subida`)
};

const fr_link_editor_banner_uploaded = /** @type {(inputs: Link_Editor_Banner_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image de bannière téléchargée`)
};

const de_link_editor_banner_uploaded = /** @type {(inputs: Link_Editor_Banner_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bannerbild hochgeladen`)
};

/** @type {(inputs: Link_Editor_Banner_UploadedInputs) => LocalizedString} */
const ja_link_editor_banner_uploaded = en_link_editor_banner_uploaded;

/** @type {(inputs: Link_Editor_Banner_UploadedInputs) => LocalizedString} */
const zh_link_editor_banner_uploaded = en_link_editor_banner_uploaded;

/** @type {(inputs: Link_Editor_Banner_UploadedInputs) => LocalizedString} */
const ar_link_editor_banner_uploaded = en_link_editor_banner_uploaded;

/** @type {(inputs: Link_Editor_Banner_UploadedInputs) => LocalizedString} */
const id_link_editor_banner_uploaded = en_link_editor_banner_uploaded;

/** @type {(inputs: Link_Editor_Banner_UploadedInputs) => LocalizedString} */
const it_link_editor_banner_uploaded = en_link_editor_banner_uploaded;

/** @type {(inputs: Link_Editor_Banner_UploadedInputs) => LocalizedString} */
const ru_link_editor_banner_uploaded = en_link_editor_banner_uploaded;

/** @type {(inputs: Link_Editor_Banner_UploadedInputs) => LocalizedString} */
const pt_link_editor_banner_uploaded = en_link_editor_banner_uploaded;

/** @type {(inputs: Link_Editor_Banner_UploadedInputs) => LocalizedString} */
const ko_link_editor_banner_uploaded = en_link_editor_banner_uploaded;

/**
* | output |
* | --- |
* | "Banner image uploaded" |
*
* @param {Link_Editor_Banner_UploadedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_banner_uploaded = /** @type {((inputs?: Link_Editor_Banner_UploadedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_Banner_UploadedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_banner_uploaded(inputs)
	if (locale === "es") return es_link_editor_banner_uploaded(inputs)
	if (locale === "fr") return fr_link_editor_banner_uploaded(inputs)
	if (locale === "de") return de_link_editor_banner_uploaded(inputs)
	if (locale === "ja") return ja_link_editor_banner_uploaded(inputs)
	if (locale === "zh") return zh_link_editor_banner_uploaded(inputs)
	if (locale === "ar") return ar_link_editor_banner_uploaded(inputs)
	if (locale === "id") return id_link_editor_banner_uploaded(inputs)
	if (locale === "it") return it_link_editor_banner_uploaded(inputs)
	if (locale === "ru") return ru_link_editor_banner_uploaded(inputs)
	if (locale === "pt") return pt_link_editor_banner_uploaded(inputs)
	return ko_link_editor_banner_uploaded(inputs)
});